import * as CONSTANTS from '../constants/constants';

import { GoalActions } from 'types';

import { handleSamaritanApiError } from './error';
import { handleSamaritanApiResponse } from './index';

import {
    catchUpItemFailure,
    catchUpItemSubmit,
    catchUpItemSuccess,
    completeItem,
    snoozeItemRequest
} from './catch_up_items';
import {
    updateBonusAmount,
    updateHomelessBalance,
    updateProfileCompletedItems
} from './homeless';
import { memoGoalActionStatusUpdated } from './local';
import { setGoalActionCompletePopup } from './samaritan';

import * as api from '../../api/goal_actions';
import { postHomelessGoal } from '../../api/goals';
import { postingNewGoal, postedNewGoal, failedNewGoal } from './goals';

import randomString from '../../util/randomString';

export function addNewGoalAction(goalAction: GoalActions) {
    return {
        type: CONSTANTS.ADD_NEW_HOMELESS_GOAL_ACTION,
        payload: goalAction
    };
}

function fetchHomelessGoalActions() {
    return {
        type: CONSTANTS.GET_HOMELESS_GOAL_ACTIONS
    };
}

// TODO: Fix any types
function setHomelessGoalActions(response: any) {
    return {
        type: CONSTANTS.SET_HOMELESS_GOAL_ACTIONS,
        payload: response
    };
}

function setHomelessGoalActionRequestState({
    id,
    requestState
}: {
    id: number;
    requestState: string;
}) {
    return {
        type: CONSTANTS.SET_HOMELESS_GOAL_ACTION_REQUEST_STATE,
        payload: { id, requestState }
    };
}

function updateHomelessGoalActionStatus(id: number, status: string) {
    return {
        type: CONSTANTS.UPDATE_HOMELESS_GOAL_ACTION_STATUS,
        payload: { id, status }
    };
}

// function updateHomelessGoalActionPendingPayments(id, pendingPayments) {
//     return {
//         type: CONSTANTS.UPDATE_HOMELESS_GOAL_ACTION_PENDING_PAYMENTS,
//         payload: { id, pendingPayments }
//     };
// }

export function updateGoalActionStatus(
    id: number,
    status: 'cancelled' | 'completed',
    catchUpItemID?: number
) {
    return (dispatch: Function) => {
        dispatch(
            setHomelessGoalActionRequestState({ id, requestState: 'loading' })
        );

        if (catchUpItemID) {
            dispatch(catchUpItemSubmit(catchUpItemID));
        }
        return api
            .updateGoalActionStatus({ id, status })
            .then((response: any) => {
                return handleSamaritanApiResponse(response, dispatch);
            })
            .then((responseJson: any) => {
                if (responseJson.errors) {
                    throw responseJson.errors;
                }

                dispatch(updateHomelessGoalActionStatus(id, status));
                dispatch(
                    setHomelessGoalActionRequestState({
                        id,
                        requestState: 'idle'
                    })
                );
                dispatch(memoGoalActionStatusUpdated(id));

                if (status === 'completed') {
                    dispatch(setGoalActionCompletePopup(true));
                    dispatch(
                        updateHomelessBalance(
                            responseJson.goal_action.match_value
                        )
                    );
                }

                if (catchUpItemID) {
                    dispatch(catchUpItemSuccess(catchUpItemID));

                    setTimeout(() => {
                        dispatch(completeItem(catchUpItemID));
                    }, 2500);
                }
            })
            .catch((error: { description: string }[]) => {
                if (catchUpItemID) {
                    dispatch(catchUpItemFailure(catchUpItemID));
                }

                dispatch(
                    setHomelessGoalActionRequestState({
                        id,
                        requestState: 'idle'
                    })
                );

                console.log('goal action status error', error);
                handleSamaritanApiError(
                    { message: 'update goal action status error' },
                    dispatch
                );
            });
    };
}
export function handleGoalActionLocally(
    id: number,
    status: 'cancelled' | 'completed',
    goalAction?: any,
    catchUpItemID?: number
) {
    return (dispatch: Function) => {
        dispatch(updateHomelessGoalActionStatus(id, status));
        dispatch(setHomelessGoalActionRequestState({ id, requestState: 'idle' }));
        dispatch(memoGoalActionStatusUpdated(id));

        if (status === 'completed') {
            dispatch(setGoalActionCompletePopup(true));

            if (goalAction?.match_value) {
                dispatch(updateHomelessBalance(goalAction.match_value));
            }
        }

        if (catchUpItemID) {
            dispatch(catchUpItemSuccess(catchUpItemID));
            setTimeout(() => {
                dispatch(completeItem(catchUpItemID));
            }, 2500);
        }
    };
}

  
function updateHomelessGoalActionMatchAmount(id: number, matchAmount: number) {
    return {
        type: CONSTANTS.UPDATE_HOMELESS_GOAL_ACTION_MATCH_AMOUNT,
        payload: { id, matchAmount }
    };
}

export function updateGoalActionMatchAmount(
    _token: string,
    id: number,
    matchAmount: number
) {
    return (dispatch: Function) => {
        return api
            .updateGoalActionMatchAmount({ id, matchAmount })
            .then((response) => {
                return handleSamaritanApiResponse(response, dispatch);
            })
            .then((responseJson) => {
                dispatch(
                    updateHomelessGoalActionMatchAmount(
                        responseJson.goal_action.id,
                        matchAmount
                    )
                );
            })
            .catch((error) => {
                handleSamaritanApiError(error, dispatch);
            });
    };
}

// TODO: Fix any types
export function getHomelessGoalActions(_token: string, id: number) {
    return (dispatch: Function) => {
        dispatch(fetchHomelessGoalActions());
        return api
            .fetchGoalActions(id)
            .then((response: any) => {
                return handleSamaritanApiResponse(response, dispatch);
            })
            .then((responseJson: { goal_actions: any[] }) => {
                return dispatch(
                    setHomelessGoalActions(responseJson.goal_actions)
                );
            })
            .catch((error: any) => {
                handleSamaritanApiError(error, dispatch);
            });
    };
}

// TODO: Fix any types
function postingNewGoalAction(payload: any, tempRef: string) {
    return {
        type: CONSTANTS.POSTING_NEW_HOMELESS_GOAL_ACTION,
        payload,
        tempRef
    };
}

// TODO: Fix any types
function postedNewGoalAction(tempRef: string, newGoalAction: any) {
    return {
        type: CONSTANTS.POSTED_NEW_HOMELESS_GOAL_ACTION,
        tempRef,
        newGoalAction
    };
}

function failedNewGoalAction(tempRef: string, error: string) {
    return {
        type: CONSTANTS.FAILED_NEW_HOMELESS_GOAL_ACTION,
        tempRef,
        error
    };
}

// TODO: Fix any types
function editingGoalAction(payload: any, tempRef: string) {
    return {
        type: CONSTANTS.EDITING_HOMELESS_GOAL_ACTION,
        payload,
        tempRef
    };
}

// TODO: Fix any types
function editedGoalAction(tempRef: string, newGoalAction: any) {
    return {
        type: CONSTANTS.EDITED_HOMELESS_GOAL_ACTION,
        tempRef,
        newGoalAction
    };
}

function failedEditGoalAction(tempRef: string, error: string) {
    return {
        type: CONSTANTS.FAILED_EDIT_HOMELESS_GOAL_ACTION,
        tempRef,
        error
    };
}

// TODO: Fix any types
export function newGoalActionThunk(
    homeless_id: number,
    goal_id: number,
    goalDescription: string,
    date: string,
    amount: number,
    customGoalDescription: string | null,
    qols: number | null,
    classification?: 'gap_in_care' | 'capital_foundation_pool'
) {
    const tempRef = randomString();

    return (dispatch: Function) => {
        dispatch(
            postingNewGoalAction(
                {
                    goal: goalDescription,
                    action: customGoalDescription,
                    due_at: date,
                    stake_match_amount: amount,
                    quality_of_life_measure_id: qols
                },
                tempRef
            )
        );

        return api
            .postNewGoalAction({
                goal_id,
                description: goalDescription,
                homeless_id,
                due_at: date,
                stake_match_amount: amount,
                qol_measure_id: qols,
                classification
            })
            .then((res: Response) => {
                return handleSamaritanApiResponse(res, dispatch);
            })
            .then(
                (resJson: {
                    errors?: {
                        due_at: string[];
                    };
                    goal_action: GoalActions;
                }) => {
                    if (resJson.errors) {
                        return dispatch(
                            failedNewGoalAction(
                                tempRef,
                                resJson.errors.due_at[0]
                            )
                        );
                    } else {
                        if (classification !== 'gap_in_care') {
                            dispatch(
                                updateBonusAmount(
                                    resJson.goal_action.match_value,
                                    classification
                                )
                            );
                        }
                        dispatch(updateProfileCompletedItems('action_steps'));
                        return dispatch(
                            postedNewGoalAction(tempRef, resJson.goal_action)
                        );
                    }
                }
            )
            .catch((e: any) => {
                dispatch(failedNewGoalAction(tempRef, e.error));
                return handleSamaritanApiError(e, dispatch);
            });
    };
}

// TODO: Fix any types
export function editGoalActionThunk(
    goalAction: string,
    amount: number,
    date: string,
    action_step_id: number,
    goal_id: null | number,
    qols: number[],
    catchUpItemID?: number
) {
    const tempRef = randomString();

    return async (dispatch: Function, getState: any) => {
        try {
            if (catchUpItemID) {
                dispatch(catchUpItemSubmit(catchUpItemID));
            }

            const payload = {
                goal_action: {
                    due_at: date,
                    stake_match_amount: amount,
                    description: goalAction,
                    quality_of_life_measure_id: qols,
                    goal_id: goal_id
                }
            };

            if (goal_id) {
                const homeless_id = getState().homeless.homelessInfo.id;
                const currentGoals = getState().goalActions.homelessGoalActions;
                const matchedGoals = currentGoals.find(
                    (goalItem: { goal: { id: number } }) =>
                        goalItem.goal.id === goal_id
                );

                if (!matchedGoals) {
                    const goalPayload = {
                        homeless_id,
                        description: goalAction
                    };

                    dispatch(postingNewGoal(goalPayload, tempRef));

                    let res;

                    try {
                        res = await postHomelessGoal({
                            homelessId: homeless_id,
                            description: goalAction
                        });

                        if (!res || !res.ok) {
                            const errorDetails = await res.json().catch(() => ({
                                error: 'Failed to parse error response'
                            }));
                            return dispatch(
                                failedNewGoal(tempRef, errorDetails.error)
                            );
                        }

                        const resJson = await res.json();
                        dispatch(postedNewGoal(tempRef, resJson.goal));

                        payload.goal_action.goal_id = resJson.goal.id;
                    } catch (error) {
                        console.error('Error posting homeless goal:', error);
                        return dispatch(
                            failedNewGoal(tempRef, 'Unexpected error occurred')
                        );
                    }
                }
            }

            if (!goal_id) {
                payload.goal_action.goal_id = null;
            }

            dispatch(editingGoalAction(payload, tempRef));

            let res;

            try {
                res = await api.editGoalAction(payload, action_step_id);
                if (!res || !res.ok) {
                    const resJson = await res.json().catch(() => ({
                        error: 'Failed to parse error response'
                    }));
                    if (catchUpItemID) {
                        dispatch(catchUpItemFailure(catchUpItemID));
                    }
                    return dispatch(
                        failedEditGoalAction(tempRef, resJson.error)
                    );
                }
                const resJson = await res.json();
                if (catchUpItemID) {
                    dispatch(catchUpItemSuccess(catchUpItemID));
                    setTimeout(() => {
                        dispatch(completeItem(catchUpItemID));
                    }, 2500);
                }
                return dispatch(editedGoalAction(tempRef, resJson.goal_action));
            } catch (error) {
                console.error('Error editing goal action:', error);

                if (catchUpItemID) {
                    dispatch(catchUpItemFailure(catchUpItemID));
                }

                return dispatch(
                    failedEditGoalAction(tempRef, 'Unexpected error occurred')
                );
            }
        } catch (error) {
            console.error('Unexpected error in editGoalActionThunk:', error);
            return dispatch(
                failedEditGoalAction(tempRef, 'Unexpected error occurred')
            );
        }
    };
}

export function sendGoalActionReminder(
    goalActionID: number,
    catchUpItemID?: number
) {
    return async (dispatch: Function) => {
        try {
            if (catchUpItemID) {
                dispatch(catchUpItemSubmit(catchUpItemID));
            }

            const res = await api.sendReminder(goalActionID);
            const resJson = await res.json();

            if (res && !res.ok) {
                if (catchUpItemID) {
                    dispatch(catchUpItemFailure(catchUpItemID));
                }

                throw resJson;
            } else {
                if (catchUpItemID) {
                    dispatch(catchUpItemSuccess(catchUpItemID));

                    setTimeout(() => {
                        dispatch(snoozeItemRequest(catchUpItemID));
                    }, 2000);
                    setTimeout(() => {
                        dispatch(completeItem(catchUpItemID));
                    }, 2500);
                }
            }
        } catch (error: any) {
            if (catchUpItemID) {
                dispatch(catchUpItemFailure(catchUpItemID));
            }

            handleSamaritanApiError(error, dispatch);
        }
    };
}